var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-badge',{staticClass:"state-badge",attrs:{"variant":_vm.state.variant}},[(_vm.busy)?_c('loader',{attrs:{"inline":""}}):[_vm._v(_vm._s(_vm.state.text))]],2)}
var staticRenderFns = []

export { render, staticRenderFns }